export const GRID_CONFIG = {
  breakpoints: { lg: 1200, md: 996, sm: 768, xs: 480, xxs: 0 },
  cols: { lg: 12, md: 10, sm: 6, xs: 4, xxs: 2 },
  rowHeight: 100,
  margin: [16, 16],
  containerPadding: [16, 16],
  draggableHandle: ".widget-drag-handle",
  resizeHandles: ["se"],
};

export const WIDGET_DEFINITIONS = [
  {
    id: "kpis",
    title: "Key Performance Indicators",
    contentType: "component",
    componentType: "KPIs",
    defaultLayout: {
      lg: { x: 0, y: 0, w: 12, h: 3 },
      md: { x: 0, y: 0, w: 10, h: 3 },
      sm: { x: 0, y: 0, w: 6, h: 3 },
      xs: { x: 0, y: 0, w: 4, h: 3 },
      xxs: { x: 0, y: 0, w: 2, h: 3 },
    },
    isVisible: true,
    isRemovable: true,
  },
  {
    id: "trends",
    title: "Trends",
    contentType: "component",
    componentType: "Trends",
    defaultLayout: {
      lg: { x: 0, y: 3, w: 12, h: 4 },
      md: { x: 0, y: 3, w: 10, h: 4 },
      sm: { x: 0, y: 3, w: 6, h: 4 },
      xs: { x: 0, y: 3, w: 4, h: 4 },
      xxs: { x: 0, y: 3, w: 2, h: 4 },
    },
    isVisible: true,
    isRemovable: true,
  },
  {
    id: "customers-table",
    title: "Customers",
    contentType: "component",
    componentType: "CustomersTable",
    defaultLayout: {
      lg: { x: 0, y: 7, w: 12, h: 6 },
      md: { x: 0, y: 7, w: 10, h: 6 },
      sm: { x: 0, y: 7, w: 6, h: 6 },
      xs: { x: 0, y: 7, w: 4, h: 6 },
      xxs: { x: 0, y: 7, w: 2, h: 6 },
    },
    isVisible: true,
    isRemovable: true,
  },
  {
    id: "tools-table",
    title: "Tools",
    contentType: "component",
    componentType: "ToolsTable",
    defaultLayout: {
      lg: { x: 0, y: 13, w: 12, h: 6 },
      md: { x: 0, y: 13, w: 10, h: 6 },
      sm: { x: 0, y: 13, w: 6, h: 6 },
      xs: { x: 0, y: 13, w: 4, h: 6 },
      xxs: { x: 0, y: 13, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "scans-table",
    title: "Scans",
    contentType: "component",
    componentType: "ScansTable",
    defaultLayout: {
      lg: { x: 0, y: 19, w: 12, h: 6 },
      md: { x: 0, y: 19, w: 10, h: 6 },
      sm: { x: 0, y: 19, w: 6, h: 6 },
      xs: { x: 0, y: 19, w: 4, h: 6 },
      xxs: { x: 0, y: 19, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "controls-table",
    title: "Controls",
    contentType: "component",
    componentType: "ControlsTable",
    defaultLayout: {
      lg: { x: 0, y: 25, w: 12, h: 6 },
      md: { x: 0, y: 25, w: 10, h: 6 },
      sm: { x: 0, y: 25, w: 6, h: 6 },
      xs: { x: 0, y: 25, w: 4, h: 6 },
      xxs: { x: 0, y: 25, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "entities-by-type-table",
    title: "Entities by Type",
    contentType: "component",
    componentType: "EntitiesByTypeTable",
    defaultLayout: {
      lg: { x: 0, y: 31, w: 12, h: 6 },
      md: { x: 0, y: 31, w: 10, h: 6 },
      sm: { x: 0, y: 31, w: 6, h: 6 },
      xs: { x: 0, y: 31, w: 4, h: 6 },
      xxs: { x: 0, y: 31, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "entities-by-environment-table",
    title: "Entities by Environment",
    contentType: "component",
    componentType: "EntitiesByEnvironmentTable",
    defaultLayout: {
      lg: { x: 0, y: 37, w: 12, h: 6 },
      md: { x: 0, y: 37, w: 10, h: 6 },
      sm: { x: 0, y: 37, w: 6, h: 6 },
      xs: { x: 0, y: 37, w: 4, h: 6 },
      xxs: { x: 0, y: 37, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "integrations-by-customer",
    title: "Total Integrations by Customer",
    contentType: "component",
    componentType: "IntegrationsByCustomer",
    defaultLayout: {
      lg: { x: 0, y: 43, w: 12, h: 4 },
      md: { x: 0, y: 43, w: 10, h: 4 },
      sm: { x: 0, y: 43, w: 6, h: 4 },
      xs: { x: 0, y: 43, w: 4, h: 4 },
      xxs: { x: 0, y: 43, w: 2, h: 4 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "entities-by-environment",
    title: "Total Entities by Environment",
    contentType: "component",
    componentType: "EntitiesByEnvironment",
    defaultLayout: {
      lg: { x: 0, y: 47, w: 12, h: 4 },
      md: { x: 0, y: 47, w: 10, h: 4 },
      sm: { x: 0, y: 47, w: 6, h: 4 },
      xs: { x: 0, y: 47, w: 4, h: 4 },
      xxs: { x: 0, y: 47, w: 2, h: 4 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "skipped-analyzers-table",
    title: "Skipped Analyzers",
    contentType: "component",
    componentType: "SkippedAnalyzersTable",
    defaultLayout: {
      lg: { x: 0, y: 51, w: 12, h: 6 },
      md: { x: 0, y: 51, w: 10, h: 6 },
      sm: { x: 0, y: 51, w: 6, h: 6 },
      xs: { x: 0, y: 51, w: 4, h: 6 },
      xxs: { x: 0, y: 51, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "skipped-detectors-table",
    title: "Skipped Detectors",
    contentType: "component",
    componentType: "SkippedDetectorsTable",
    defaultLayout: {
      lg: { x: 0, y: 57, w: 12, h: 6 },
      md: { x: 0, y: 57, w: 10, h: 6 },
      sm: { x: 0, y: 57, w: 6, h: 6 },
      xs: { x: 0, y: 57, w: 4, h: 6 },
      xxs: { x: 0, y: 57, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "entities-by-customer",
    title: "Total Entities by Customer",
    contentType: "component",
    componentType: "EntitiesByCustomer",
    defaultLayout: {
      lg: { x: 0, y: 63, w: 12, h: 4 },
      md: { x: 0, y: 63, w: 10, h: 4 },
      sm: { x: 0, y: 63, w: 6, h: 4 },
      xs: { x: 0, y: 63, w: 4, h: 4 },
      xxs: { x: 0, y: 63, w: 2, h: 4 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "non-applicable-controls",
    title: "Non-Applicable Controls",
    contentType: "component",
    componentType: "NonApplicableControls",
    defaultLayout: {
      lg: { x: 0, y: 67, w: 12, h: 6 },
      md: { x: 0, y: 67, w: 10, h: 6 },
      sm: { x: 0, y: 67, w: 6, h: 6 },
      xs: { x: 0, y: 67, w: 4, h: 6 },
      xxs: { x: 0, y: 67, w: 2, h: 6 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "tags-usage",
    title: "Tags Usage",
    contentType: "component",
    componentType: "TagsUsage",
    defaultLayout: {
      lg: { x: 0, y: 78, w: 6, h: 5 },
      md: { x: 0, y: 78, w: 5, h: 5 },
      sm: { x: 0, y: 78, w: 6, h: 5 },
      xs: { x: 0, y: 78, w: 4, h: 5 },
      xxs: { x: 0, y: 78, w: 2, h: 5 },
    },
    isVisible: false,
    isRemovable: true,
  },
  {
    id: "assignments-usage",
    title: "Assignments Usage",
    contentType: "component",
    componentType: "AssignmentsUsage",
    defaultLayout: {
      lg: { x: 6, y: 78, w: 6, h: 5 },
      md: { x: 5, y: 78, w: 5, h: 5 },
      sm: { x: 0, y: 83, w: 6, h: 5 },
      xs: { x: 0, y: 83, w: 4, h: 5 },
      xxs: { x: 0, y: 83, w: 2, h: 5 },
    },
    isVisible: false,
    isRemovable: true,
  },
];
